<!-- components/MobileMenu.vue -->
<template>
  <transition name="slide">
    <nav
      v-if="open"
      class="md:hidden fixed inset-0 bg-white z-50 flex flex-col overflow-y-auto mt-13"
      role="dialog"
      aria-modal="true"
    >
      <!-- ROOT -->
      <aside v-if="view === 'root'" class="flex flex-col flex-grow pt-6">
        <!-- Каталог з правою стрілкою (йдемо вглиб до списку категорій) -->
        <div class="relative" @click="openCats">
          <button
            class="w-full text-center font-bold text-lg py-3 hover:bg-gray-50"
          >
            Каталог
          </button>
          <button
            class="absolute right-4 top-1/2 -translate-y-1/2 p-2 rounded-lg hover:bg-gray-100"
            aria-label="Відкрити каталог"
          >
            <ChevronRight class="w-6 h-6" />
          </button>
        </div>

        <!-- Доставка/Оплата -->
        <NuxtLink
          to="/delivery"
          class="text-center font-bold text-lg py-3 hover:bg-gray-50"
          @click="closeMenu"
        >
          Доставка/Оплата
        </NuxtLink>

        <!-- Контакти -->
        <NuxtLink
          to="/contacts"
          class="text-center font-bold text-lg py-3 hover:bg-gray-50"
          @click="closeMenu"
        >
          Контакти
        </NuxtLink>
      </aside>

      <!-- CATEGORIES (один рівень) -->
      <aside v-else-if="view === 'cats'" class="flex flex-col flex-grow pt-2">
        <!-- Шапка -->
        <div class="flex items-center gap-2 px-4 pb-2" @click="goBack">
          <button class="p-2 -ml-2" aria-label="Назад">
            <ChevronLeft class="w-6 h-6" />
          </button>
          <h3 class="font-semibold">Каталог</h3>
        </div>

        <div class="flex flex-col">
          <div
            v-for="c in topLevelCats"
            :key="c.id"
            class="relative"
            @click="goCategory(c.slug)"
          >
            <!-- Натиск по назві → одразу у каталог з цією категорією -->
            <button
              class="w-full text-center font-bold text-lg py-3 hover:bg-gray-50"
            >
              {{ c.label }}
            </button>
            <!-- Стрілка праворуч робить те саме (нема подальших рівнів) -->
            <!-- <button
              class="absolute right-4 top-1/2 -translate-y-1/2 p-2 rounded-lg hover:bg-gray-100"
              aria-label="Перейти в категорію"
              @click.stop="goCategory(c.slug)"
            >
              <ChevronRight class="w-6 h-6" />
            </button> -->
          </div>

          <div
            v-if="!topLevelCats.length"
            class="px-4 py-6 text-center text-gray-500"
          >
            Немає категорій для відображення
          </div>

          <!-- Кнопка "Всі товари" (опційно) -->
          <div class="p-4">
            <button
              class="font-bold text-lg w-full inline-flex items-center justify-center px-4 py-3 rounded-xl border hover:bg-gray-50"
              @click="goAll"
            >
              Всі товари
            </button>
          </div>
        </div>
      </aside>

      <!-- Соц мережі -->
      <div class="flex justify-center gap-8 py-5 border-t mt-3">
        <a
          href="https://www.instagram.com/mulberry_silk_studio/"
          target="_blank"
          class="rounded-full p-2 hover:bg-gray-200 transition"
        >
          <Instagram :size="36" />
        </a>
      </div>
    </nav>
  </transition>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { Instagram, ChevronRight, ChevronLeft } from "lucide-vue-next";
import { useCategoriesData } from "~/composables/useCategoriesData";

const props = defineProps({ open: { type: Boolean, default: false } });
const emit = defineEmits(["close"]);

const router = useRouter();
const route = useRoute();

// Публічне джерело правди — /api/categories (SSR + кеш, дедуп по ключу).
const { cats } = useCategoriesData();

// Стани
const view = ref("root");

// Тільки верхній рівень
const topLevelCats = computed(() => cats.value.filter((c) => !c.parentId));

// Завжди ресет при відкритті/закритті
watch(
  () => props.open,
  () => {
    view.value = "root";
  },
);

watch(
  () => route.fullPath,
  () => {
    if (props.open) closeMenu();
  },
);

function closeMenu() {
  emit("close");
  view.value = "root";
}

function openCats() {
  view.value = "cats";
}

function goCategory(slug) {
  closeMenu();
  if (!slug) router.push({ path: "/catalog" });
  else router.push({ path: "/catalog", query: { cat: slug } });
}

function goAll() {
  closeMenu();
  router.push({ path: "/catalog" });
}

function goBack() {
  view.value = "root";
}
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: opacity 0.2s;
}
.slide-enter-from,
.slide-leave-to {
  opacity: 0;
}
</style>
